import { createContext } from 'react';
import type { AppNoticesContextValue } from '../../types/notices/app-notice.type';

/** Shared presentation registry; accessed through useAppNotices. */
export const AppNoticesContext = createContext<AppNoticesContextValue | null>(
  null
);
